"use strict";

exports.__esModule = true;
var _TicketingContext = require("./TicketingContext");
Object.keys(_TicketingContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketingContext[key]) return;
  exports[key] = _TicketingContext[key];
});
var _TicketingController = require("./TicketingController");
Object.keys(_TicketingController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketingController[key]) return;
  exports[key] = _TicketingController[key];
});